import React from "react";
import { Badge, Image, Space, Tag } from "antd";
import { NumericFormat } from "react-number-format";

import Won from "../../assets/images/home/rent/icon_won.svg";
import styles from "./GoodsCard.module.css";

import * as String from "../../commons/string";
import * as TypeDTO from "../../commons/typeDTO";
import * as Utils from "../../utils/utils";

function GoodsCard({
    alignType,
    rentCar,
    disabledPrice,
    onClick,
}: {
    alignType?: boolean;
    rentCar: TypeDTO.RentCarDto;
    disabledPrice?: boolean;
    onClick: (carId: number, b2bId?: number) => void;
}) {
    const tags = rentCar.rentRestrictions.map((restriction) => restriction.rentRestrictionName);

    return (
        <div className={`${styles.body} mb-4`} onClick={() => onClick(rentCar.rentCarId, rentCar?.b2b?.b2bId)}>
            <Badge.Ribbon
                text={
                    <span className={styles.middleText}>
                        {String.coupon} {String.available}
                    </span>
                }
                className={styles.badge}
            >
                <Image className={styles.image} src={Utils.getCarImage(rentCar.title.toString())} preview={false} />
            </Badge.Ribbon>
            <p style={{ fontSize: "13px", color: "#1b2b41b0" }}>{rentCar.rentRegion.rentRegionName}</p>
            <h6 className={styles.title} style={{ fontSize: "16px" }}>
                {rentCar.title}
            </h6>
            {!disabledPrice &&
                (alignType ? (
                    <Space size={3} style={{ display: "flex", alignItems: "center", alignContent: "center", flexWrap: "wrap" }}>
                        <img src={Won} />
                        {rentCar?.discountPrice ? (
                            <NumericFormat
                                className={styles.priceDiscounted}
                                value={rentCar.discountPrice}
                                thousandSeparator={true}
                                suffix="~"
                                displayType="text"
                            />
                        ) : (
                            <p className={styles.priceDiscounted}>무료</p>
                        )}

                        <NumericFormat className={styles.price} value={rentCar.price} thousandSeparator={true} displayType="text" suffix="원" />
                        <NumericFormat
                            className={styles.discountRate}
                            value={Utils.getDiscountRate(rentCar.price, rentCar.discountPrice)}
                            thousandSeparator={true}
                            displayType="text"
                            suffix="%"
                        />
                    </Space>
                ) : (
                    <>
                        <p className={styles.description}>{rentCar.description}</p>
                        <div style={{ display: "flex", alignItems: "center", alignContent: "center", flexWrap: "wrap" }}>
                            <NumericFormat
                                className={styles.discountRate}
                                value={Utils.getDiscountRate(rentCar.price, rentCar.discountPrice)}
                                style={{ marginRight: "8px" }}
                                thousandSeparator={true}
                                displayType="text"
                                suffix="%"
                            />
                            <NumericFormat className={styles.price} value={rentCar.price} thousandSeparator={true} displayType="text" suffix="원" />
                        </div>
                        <div style={{ display: "flex", alignContent: "center", flexFlow: "wrap", alignItems: "center" }}>
                            <img src={Won} />
                            {rentCar?.discountPrice ? (
                                <NumericFormat
                                    className={styles.priceDiscounted}
                                    value={rentCar.discountPrice}
                                    thousandSeparator={true}
                                    displayType="text"
                                    suffix="~"
                                />
                            ) : (
                                <p className={styles.priceDiscounted}>무료</p>
                            )}
                        </div>
                    </>
                ))}
            <div className={styles.tagBody}>
                {tags.map((tag: string) => (
                    <Tag key={tag} className={styles.tag}>
                        {tag}
                    </Tag>
                ))}
            </div>
        </div>
    );
}
export default GoodsCard;
